var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRailType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.168 23.9744C31.168 22.4138 29.9715 21.1139 28.4162 20.9847L7.00602 19.207L3.98578 20.0095V33.2502H28.168C29.8248 33.2502 31.168 31.9071 31.168 30.2502V23.9744Z",
    fill: "#42C67E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13672 19.207L0.833602 20.812V33.2502H7.13672V19.207Z",
    fill: "#399E67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0469 25.9035V11.1398C13.0469 10.9087 13.2053 10.7077 13.4301 10.6537L27.7954 7.20187C27.8774 7.18219 27.9629 7.18353 28.0442 7.20574L42.2246 11.0835C42.442 11.143 42.5927 11.3405 42.5927 11.5658V24.3689C42.5927 24.6346 42.3849 24.8539 42.1196 24.8681L13.5737 26.4028C13.2874 26.4182 13.0469 26.1902 13.0469 25.9035Z",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6523 25.9151V29.8433C12.6523 30.3956 13.1001 30.8433 13.6523 30.8433H29.198V23.6211L23.2193 24.137L22.3851 25.3407L17.5187 25.6846L16.6845 24.6528L13.5674 24.9187C13.0499 24.9628 12.6523 25.3957 12.6523 25.9151Z",
    fill: "#3F3F3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6523 20.2872V23.7336C12.6523 24.3191 13.153 24.7793 13.7364 24.7301L29.198 23.426V16.7969L22.9401 17.8436L22.4326 19.0647L17.0202 19.7625L16.5129 18.8903L13.518 19.2963C13.0222 19.3635 12.6523 19.7868 12.6523 20.2872Z",
    fill: "#3F3F3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6523 14.0382V18.0328C12.6523 18.6481 13.2028 19.1174 13.8103 19.0202L29.198 16.558V8.77344L22.9336 10.4357L22.4255 11.6992L16.8589 13.1133L16.5193 12.2332L13.3931 13.0724C12.9561 13.1896 12.6523 13.5857 12.6523 14.0382Z",
    fill: "#3F3F3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6523 8.25191V11.8758C12.6523 12.5361 13.2811 13.0152 13.9178 12.8399L29.198 8.6334V0.75L22.9321 3.67485L22.424 4.95448L17.1955 6.88153L16.5178 5.99027L13.2715 7.32726C12.8969 7.48157 12.6523 7.84672 12.6523 8.25191Z",
    fill: "#3F3F3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0722 24.7188L29.1992 23.6211V30.6753L41.9751 30.831C42.5321 30.8378 42.9873 30.3881 42.9873 29.831V25.7152C42.9873 25.1958 42.5897 24.7629 42.0722 24.7188Z",
    fill: "#5A5A5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1685 19.1871L29.1992 16.7969V23.2344L41.9016 24.3269C42.4855 24.3772 42.9873 23.9167 42.9873 23.3306V20.1706C42.9873 19.6882 42.6429 19.2746 42.1685 19.1871Z",
    fill: "#5A5A5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3048 13.1624L29.1992 8.77344V16.4692L41.7926 18.9684C42.411 19.0912 42.9873 18.618 42.9873 17.9876V14.1106C42.9873 13.6807 42.7125 13.2989 42.3048 13.1624Z",
    fill: "#5A5A5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4382 7.43847L29.1992 0.75V8.5239L41.6668 12.7416C42.3152 12.9609 42.9873 12.4787 42.9873 11.7943V8.33103C42.9873 7.95375 42.775 7.60859 42.4382 7.43847Z",
    fill: "#5A5A5A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.4727,
    y: 30.8438,
    width: 18.5154,
    height: 1.2037,
    rx: 0.601851,
    fill: "#919191"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6523,
    y: 30.8438,
    width: 5.51523,
    height: 1.2037,
    rx: 0.601851,
    fill: "#C8C8C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6836,
    y: 30.4414,
    width: 20.4851,
    height: 1.2037,
    rx: 0.601851,
    fill: "#AFAFAF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4395,
    y: 30.4414,
    width: 5.51523,
    height: 1.2037,
    rx: 0.601851,
    fill: "#C8C8C8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1074 4.85927V4.68957C35.1074 4.54025 35.2651 4.44359 35.3982 4.51135L36.804 5.22729C36.9716 5.31263 37.0771 5.48478 37.0771 5.67284V5.84254C37.0771 5.99186 36.9194 6.08852 36.7864 6.02076L35.3805 5.30483C35.2129 5.21949 35.1074 5.04733 35.1074 4.85927Z",
    fill: "#FCFCFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1074 12.0145V11.8523C35.1074 11.7179 35.2373 11.6217 35.3659 11.661L36.7233 12.0757C36.9335 12.14 37.0771 12.3341 37.0771 12.5539V12.7161C37.0771 12.8505 36.9472 12.9467 36.8187 12.9074L35.4613 12.4926C35.251 12.4284 35.1074 12.2343 35.1074 12.0145Z",
    fill: "#323232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1074 18.8003V18.6511C35.1074 18.5246 35.2234 18.4299 35.3473 18.4551L36.6769 18.726C36.9098 18.7734 37.0771 18.9782 37.0771 19.2159V19.3651C37.0771 19.4916 36.9612 19.5863 36.8372 19.5611L35.5076 19.2902C35.2747 19.2428 35.1074 19.038 35.1074 18.8003Z",
    fill: "#323232"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1074 25.175V25.0456C35.1074 24.9272 35.2098 24.8346 35.3277 24.8467L36.6278 24.9791C36.883 25.0051 37.0771 25.22 37.0771 25.4765V25.6059C37.0771 25.7244 36.9747 25.8169 36.8569 25.8049L35.5568 25.6725C35.3016 25.6465 35.1074 25.4315 35.1074 25.175Z",
    fill: "#323232"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4707 25.4376V25.3181C37.4707 25.2028 37.5679 25.1114 37.6829 25.1185L38.971 25.1974C39.2348 25.2136 39.4404 25.4322 39.4404 25.6965V25.816C39.4404 25.9313 39.3432 26.0227 39.2282 26.0156L37.9401 25.9367C37.6764 25.9205 37.4707 25.7019 37.4707 25.4376Z",
    fill: "#323232"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4707 6.0624V5.8927C37.4707 5.74338 37.6284 5.64671 37.7615 5.71448L39.1673 6.43041C39.3349 6.51575 39.4404 6.68791 39.4404 6.87597V7.04567C39.4404 7.19499 39.2827 7.29165 39.1497 7.22389L37.7438 6.50795C37.5762 6.42261 37.4707 6.25046 37.4707 6.0624Z",
    fill: "#FCFCFC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4707 12.8191V12.657C37.4707 12.5226 37.6006 12.4264 37.7291 12.4657L39.0865 12.8804C39.2968 12.9447 39.4404 13.1387 39.4404 13.3586V13.5208C39.4404 13.6552 39.3105 13.7513 39.182 13.7121L37.8246 13.2973C37.6143 13.2331 37.4707 13.039 37.4707 12.8191Z",
    fill: "#323232"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4707 19.2808V19.1316C37.4707 19.0051 37.5867 18.9103 37.7106 18.9356L39.0402 19.2064C39.2731 19.2539 39.4404 19.4587 39.4404 19.6964V19.8456C39.4404 19.9721 39.3245 20.0668 39.2005 20.0415L37.8709 19.7707C37.638 19.7233 37.4707 19.5184 37.4707 19.2808Z",
    fill: "#323232"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9723 6.36998L16.3965 5.96875L17.1844 6.97183L18.1692 6.5706L17.9723 6.36998Z",
    fill: "#323232"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailType);
export default __webpack_public_path__ + "static/media/railType.04e1a8e6b770c80262649693ed0ddfbc.svg";
export { ForwardRef as ReactComponent };